import { render, staticRenderFns } from "./PromotionInvitations.vue?vue&type=template&id=1154a6a5"
import script from "./PromotionInvitations.vue?vue&type=script&lang=js"
export * from "./PromotionInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports